module.exports = __webpack_public_path__ + "static/img/07-人大附中亦庄新城学校.910af42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/07-人大附中亦庄新城学校.png
// module id = 6laB
// module chunks = 0